import YaCounter from "../analytics/ym";

function updateDisabledSelectorItems($form) {
	let itemsForChange = [];

	$form.find('.radio-elem[data-disable-items]').each(function (i, e) {
		let disableVals = $(e).data('disable-items');

		disableVals = disableVals.split(',');
		for (let i in disableVals) {
			let disableVal = disableVals[i];

			let checked = $(e).prop('checked');
			if (checked) {
				itemsForChange[disableVal] = true;
			} else {
				if (typeof itemsForChange[disableVal] == 'undefined') {
					itemsForChange[disableVal] = false;
				}
			}
		}
	});

	for (let disableVal in itemsForChange) {
		let $rElem = $form.find('.radio-elem[value="' + disableVal + '"]');

		if (itemsForChange[disableVal]) {
			$rElem.attr('disabled', 'disabled');
			$rElem.closest('label').addClass('disabled');

			if ($rElem.prop('checked')) {
				$rElem.closest('.section-group').find('.radio-elem:not(:disabled)').prop('checked', 'checked').trigger('change');
			}
		} else {
			$rElem.removeAttr('disabled');
			$rElem.closest('label').removeClass('disabled');
		}
	}
}

function getSliderInstance($slider) {
	if (!$slider.length) {
		return null;
	}

	let sliderEl = $slider.get(0);
	return sliderEl ? sliderEl.swiper : null;
}

function updateColoredCover($form, colorName) {
	let $product = $form.closest('[data-product], [data-product-modal]');
	let $slider = $product.find('#swiper-prd-main');
	let $thumbSlider = $product.find('#swiper-prd-thumb');

	if (!$slider.length) {
		return;
	}

	let slider = getSliderInstance($slider);
	if (!slider) {
		return;
	}

	let thumbSlider = getSliderInstance($thumbSlider);

	let targetIndex = 0;
	let $targetSlide = colorName
		? $slider.find('.swiper-slide').filter(function () {
			return $(this).data('color') === colorName;
		}).first()
		: $();

	if ($targetSlide.length) {
		targetIndex = slider.slides.indexOf($targetSlide.get(0));
	}

	if (targetIndex < 0) {
		targetIndex = 0;
	}

	slider.slideTo(targetIndex, 0, false);

	if (thumbSlider) {
		thumbSlider.slideTo(targetIndex, 0, false);
	}
}

function updateSelectedColoredCover($form) {
	let $colorInput = $form.find('.radio-elem[name="selector[fill]"]:checked');

	if (!$colorInput.length) {
		return;
	}

	updateColoredCover($form, $colorInput.data('color-name'));
}

function updateSelectedColorFromSlide($form) {
	let $product = $form.closest('[data-product], [data-product-modal]');
	let $slider = $product.find('#swiper-prd-main');

	if (!$slider.length) {
		return;
	}

	let slider = getSliderInstance($slider);
	if (!slider) {
		return;
	}

	let $activeSlide = $(slider.slides[slider.activeIndex]);
	let colorName = $activeSlide.data('color');

	if (!colorName) {
		return;
	}

	let $colorInput = $form.find('.radio-elem[name="selector[fill]"]').filter(function () {
		return $(this).data('color-name') === colorName;
	}).first();

	if (!$colorInput.length || $colorInput.prop('disabled') || $colorInput.prop('checked')) {
		return;
	}

	$form.data('skip-colored-cover-sync', true);
	$colorInput.prop('checked', true).trigger('change');
}

function bindColorSlideSync($form) {
	let $product = $form.closest('[data-product], [data-product-modal]');
	let $slider = $product.find('#swiper-prd-main');

	if (!$slider.length || $slider.data('color-sync-bound')) {
		return;
	}

	let slider = getSliderInstance($slider);
	if (!slider) {
		return;
	}

	slider.on('slideChange', function () {
		updateSelectedColorFromSlide($form);
	});

	$slider.data('color-sync-bound', true);
}

function initColorFromQuery($form) {
	let searchParams = new URLSearchParams(window.location.search);
	let colorName = searchParams.get('color');

	if (!colorName) {
		return;
	}

	let $colorInput = $form.find('.radio-elem[name="selector[fill]"]').filter(function () {
		return $(this).data('color-name') === colorName;
	}).first();

	if (!$colorInput.length || $colorInput.prop('disabled')) {
		return;
	}

	$colorInput.prop('checked', true).trigger('change');
}

function updateColorQuery(colorName) {
	let url = new URL(window.location.href);

	if (colorName) {
		url.searchParams.set('color', colorName);
	} else {
		url.searchParams.delete('color');
	}

	window.history.replaceState({}, '', url.toString());

	setTimeout(() => {
		new YaCounter().hit();
	}, 200);
}

function initColorSliderSync($form, attemptsLeft = 10) {
	bindColorSlideSync($form);
	updateSelectedColoredCover($form);

	if (attemptsLeft <= 0) {
		return;
	}

	let $product = $form.closest('[data-product], [data-product-modal]');
	let $slider = $product.find('#swiper-prd-main');

	if (!$slider.length || $slider.data('color-sync-bound')) {
		return;
	}

	window.setTimeout(function () {
		initColorSliderSync($form, attemptsLeft - 1);
	}, 50);
}

function ready() {
	$(document).on('change', '.form-selector .radio-elem', function () {
		let $form = $(this).closest('.form-selector');

		updateDisabledSelectorItems($form);

		let $product = $(this).closest('[data-product], [data-product-modal]');
		let params = $form.serializeArray();

		$.get('/catalog/select_price', params, function (data) {
			$product.find('.price-action-area .price').text(data.price_formatted);
		});
	});

	$(document).on('change', '.form-selector .radio-elem[name="selector[fill]"]', function () {
		let $form = $(this).closest('.form-selector');
		let colorName = $(this).data('color-name');

		if ($form.data('skip-colored-cover-sync')) {
			$form.removeData('skip-colored-cover-sync');
			return;
		}

		updateColoredCover($form, colorName);
	});

	$(document).on('change', '[data-product] .form-selector .radio-elem[name="selector[fill]"]', function () {
		let colorName = $(this).data('color-name');
		updateColorQuery(colorName);
	});

	$('.form-selector').each(function () {
		let $form = $(this);

		updateDisabledSelectorItems($form);
		initColorFromQuery($form);
		initColorSliderSync($form);
	});

	$(document).on('modal-loaded', '#modal-prd-add', function () {
		let $form = $(this).find('form');

		updateDisabledSelectorItems($form);
		initColorSliderSync($form);
	});
}

$(document).ready(() => ready());
typeof onTurboRender !== 'undefined' && onTurboRender(ready);
